import { usePageTitle } from "@/hooks/use-page-title";
import { useParams } from "wouter";
import { ConditionsList } from "./condition-explorer/conditions-list";
import { ConditionDetail } from "./condition-explorer/condition-detail";
import { WalletDetail } from "./condition-explorer/wallet-detail";
import { ContributionSuccess } from "./condition-explorer/contribution-success";

export function ConditionWalletSuccessPage() {
  const params = useParams<{ walletId: string }>();
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <ContributionSuccess walletId={params.walletId!} />
      </div>
    </div>
  );
}

export default function ConditionExplorerPage() {
  usePageTitle("Explore Health Conditions & Community Funds", "Explore health conditions and join condition-specific community health funds on HealthWallet.");
  const params = useParams<{ conditionId?: string; walletId?: string }>();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {params.walletId ? (
          <WalletDetail walletId={params.walletId} />
        ) : params.conditionId ? (
          <ConditionDetail conditionId={params.conditionId} />
        ) : (
          <ConditionsList />
        )}
      </div>
    </div>
  );
}
